import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/** Styling for the Billing card's Stop Cancellation / Extend Trial dialogs. */
export const billingRenewalDialogsStyles = StyleSheet.create({
	popup: {
		maxWidth: 460,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	prompt: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	emphasis: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	dayOptions: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
});
